import { useQuery } from '@tanstack/react-query';
import { useSupabase, queryKeys } from '../provider';

// =====================================================
// SERVICE TYPE & ITEM QUERIES
// =====================================================

export function useServiceTypes() {
  const supabase = useSupabase();

  return useQuery({
    queryKey: queryKeys.services.types(),
    queryFn: async () => {
      const { data, error } = await supabase
        .from('service_types')
        .select('*')
        .eq('active', true)
        .order('service_type_name');

      if (error) throw error;
      return data;
    },
  });
}

export function useServiceItems(serviceTypeId?: string) {
  const supabase = useSupabase();

  return useQuery({
    queryKey: queryKeys.services.items(serviceTypeId),
    queryFn: async () => {
      let query = supabase
        .from('service_items')
        .select(`
          *,
          service_type:service_types(id, service_type_name, service_type_code)
        `)
        .eq('active', true)
        .order('service_item_name');

      if (serviceTypeId) {
        query = query.eq('service_type_id', serviceTypeId);
      }

      const { data, error } = await query;

      if (error) throw error;
      return data;
    },
  });
}

export function useServiceItem(itemId: string | undefined) {
  const supabase = useSupabase();

  return useQuery({
    queryKey: ['serviceItem', itemId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('service_items')
        .select(`
          *,
          service_type:service_types(*)
        `)
        .eq('id', itemId!)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: !!itemId && itemId !== 'new',
  });
}
